import React from "react";
import "./loadingScreen.css";

import { AnimatePresence, motion } from "framer-motion";

import Loading from "../../../images/LoadingScreen.mp4";

export default function LoadingScreen({ show }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="loading-screen-container"
          initial={{
            top: 0,
            opacity: 1,
          }}
          key="loading-screen"
          exit={{
            top: "100%",
            opacity: 0,
            transition: {
              duration: 0.4,
              delay: 0.2,
            },
          }}
        >
          <div className="loading-video-container">
            <motion.video
              autoPlay
              muted
              playsInline
              key="loading-video"
              initial={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
                transition: {
                  duration: 0.3,
                },
              }}
            >
              <source src={Loading} type="video/mp4" />
            </motion.video>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
